import { useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { Radio, ArrowLeft } from "lucide-react";

export default function AdminRecovery() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [devLink, setDevLink] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/auth/admin/forgot-password", { email: email.trim() });
      setSent(true);
      if (data.dev_reset_link) setDevLink(data.dev_reset_link);
    } catch { setSent(true); } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F5F3EE] p-6">
      <div className="w-full max-w-md">
        <div className="flex items-center gap-2 mb-8">
          <div className="w-9 h-9 bg-[#1C2530] flex items-center justify-center"><Radio className="w-5 h-5 text-[#F5F3EE]" strokeWidth={1.75} /></div>
          <div className="font-mono text-sm font-semibold text-[#1C2530]">VIS · ADMIN RECOVERY</div>
        </div>
        <div className="bg-white border border-[#DFDAD0] p-8 shadow-[3px_3px_0px_#DFDAD0]">
          <div className="font-mono text-[10px] uppercase tracking-[0.14em] text-[#1C2530]/60">Admin password reset</div>
          <h1 className="text-2xl font-semibold tracking-tight text-[#1C2530] mt-1 mb-4">Recover admin access</h1>
          <p className="text-sm text-[#1C2530]/60 mb-6">Available for Admin and Sales Lead accounts with MFA enabled only. You'll receive a one-time link and be asked for your authenticator code. Reps must ask an admin to reset their password.</p>
          {sent ? (
            <div data-testid="recovery-sent" className="space-y-3">
              <div className="border border-[#2F7A3E]/40 bg-[#2F7A3E]/5 px-4 py-3 text-sm text-[#1C2530]">If this is an MFA-enabled admin account, a reset link has been sent (valid 30 min).</div>
              {devLink && (
                <div className="border border-[#DFDAD0] bg-[#F5F3EE] px-3 py-2">
                  <div className="font-mono text-[9px] uppercase text-[#1C2530]/50 mb-1">Dev environment — link (email domain not yet verified):</div>
                  <a href={devLink} data-testid="dev-reset-link" className="font-mono text-xs text-[#3E8F99] break-all underline">{devLink}</a>
                </div>
              )}
            </div>
          ) : (
            <form onSubmit={submit} className="space-y-4">
              <input data-testid="recovery-email" value={email} onChange={(e) => setEmail(e.target.value)}
                className="w-full border border-[#DFDAD0] px-3 py-2 text-sm outline-none focus:border-[#1C2530]" placeholder="admin@visolutionz.com" />
              <button type="submit" disabled={busy} data-testid="recovery-submit"
                className="w-full bg-[#1C2530] text-[#F5F3EE] py-2.5 text-sm font-medium hover:bg-[#2a3644] disabled:opacity-50">
                {busy ? "Sending…" : "Send reset link"}
              </button>
            </form>
          )}
        </div>
        <Link to="/login" data-testid="back-to-login" className="mt-4 inline-flex items-center gap-1 font-mono text-[10px] uppercase text-[#1C2530]/60 hover:text-[#1C2530]"><ArrowLeft className="w-3 h-3" /> Back to sign in</Link>
      </div>
    </div>
  );
}
